import { render, staticRenderFns } from "./TabCost.vue?vue&type=template&id=f650b18c&scoped=true"
import script from "./TabCost.vue?vue&type=script&lang=ts"
export * from "./TabCost.vue?vue&type=script&lang=ts"
import style0 from "./TabCost.vue?vue&type=style&index=0&id=f650b18c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f650b18c",
  null
  
)

export default component.exports